<template>
  <b-card>
    <b-card-header class="d-flex justify-content-between align-items-center">
      <h4 class="title mb-0">لیست قراردادها</h4>
      <b-button :to="{ name: 'Contract_Create' }" variant="primary">ثبت قرارداد</b-button>
    </b-card-header>
    <b-card-body>
      <b-overlay :show="loading">
        <b-table :fields="fields" :items="contracts" hover striped responsive>
          <template #cell(expirationDate)="data">{{ data.item.expirationDate || data.item.expires_at || '-' }}</template>
          <template #cell(creator)="data">{{ data.item.creator && data.item.creator.name ? data.item.creator.name : '-' }}</template>
          <template #cell(counterpartyType)="data">{{ data.item.counterpartyType && data.item.counterpartyType.title ? data.item.counterpartyType.title : '-' }}</template>
          <template #cell(type)="data">{{ data.item.type && data.item.type.title ? data.item.type.title : data.item.type }}</template>
          <template #cell(status)="data"><b-badge :variant="statusVariant(data.item.status && data.item.status.key)">{{ data.item.status && data.item.status.title ? data.item.status.title : '-' }}</b-badge></template>
          <template #cell(remainingTime)="data">{{ data.item.remainingTime || remainingDays(data.item.remainingDays) }}</template>
          <template #cell(reminderLeadDays)="data">{{ data.item.reminderLeadDays }} روز</template>
          <template #cell(actions)="data">
            <b-button :to="{ name: 'Contract_Detail', params: { id: data.item.id } }" variant="outline-primary" size="sm">جزئیات</b-button>
          </template>
        </b-table>
        <b-pagination v-if="totalRows" v-model="currentPage" class="mt-2" :total-rows="totalRows" :per-page="perPage" />
      </b-overlay>
    </b-card-body>
  </b-card>
</template>

<script>
import { BBadge, BButton, BCard, BCardBody, BCardHeader, BOverlay, BPagination, BTable } from 'bootstrap-vue'

export default {
  name: 'ContractList',
  components: { BBadge, BButton, BCard, BCardBody, BCardHeader, BOverlay, BPagination, BTable },
  data() {
    return {
      loading: false, contracts: [], currentPage: Number(this.$route.query.page) || 1, totalRows: 0, perPage: 25,
      fields: [
        { key: 'id', label: 'شناسه' }, { key: 'name', label: 'نام قرارداد' }, { key: 'expirationDate', label: 'تاریخ انقضا' },
        { key: 'creator', label: 'ایجادکننده' }, { key: 'counterparty', label: 'طرف قرارداد' },
        { key: 'counterpartyType', label: 'نوع طرف قرارداد' }, { key: 'type', label: 'نوع قرارداد' },
        { key: 'status', label: 'وضعیت' }, { key: 'remainingTime', label: 'زمان باقی مانده' },
        { key: 'reminderLeadDays', label: 'دوره یادآوری' }, { key: 'actions', label: 'عملیات' },
      ],
    }
  },
  mounted() { this.getContracts() },
  watch: {
    currentPage(page) {
      if (page !== Number(this.$route.query.page)) {
        this.$router.replace({ query: { ...this.$route.query, page } }).catch(() => {})
        this.getContracts()
      }
    },
  },
  methods: {
    getContracts() {
      this.loading = true
      this.$http.get('contracts', { params: { page: this.currentPage } })
        .then(({ data }) => {
          if (!data.status) throw new Error(data.message || 'دریافت قراردادها با خطا مواجه شد.')
          this.contracts = data.contracts || []
          this.currentPage = data.meta && data.meta.current_page ? data.meta.current_page : this.currentPage
          this.totalRows = data.meta && data.meta.total ? data.meta.total : this.contracts.length
          this.perPage = data.meta && data.meta.per_page ? data.meta.per_page : 25
        })
        .catch(error => this.$bvToast.toast((error.response && error.response.data && error.response.data.message) || error.message, {
          title: 'خطا در دریافت قراردادها', toaster: 'b-toaster-top-right', variant: 'danger',
        }))
        .finally(() => { this.loading = false })
    },
    statusVariant(status) {
      return { ACTIVE: 'light-success', NEAR_EXPIRATION: 'light-warning', EXPIRED: 'light-danger' }[status] || 'light-secondary'
    },
    remainingDays(days) {
      if (days === 0) return 'امروز'
      if (days > 0) return `${days} روز`
      if (days < 0) return `${Math.abs(days)} روز گذشته`
      return '-'
    },
  },
}
</script>